"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var unfetch_1 = __importDefault(require("unfetch"));
var subscriptions_api_1 = require("../../misc/subscriptions-api");
var flatten_add_ons_1 = __importDefault(require("./flatten-add-ons"));
var TAGS = {
    addOn: 'Bundler App Add-On',
    autoAddOn: 'Bundler App Auto Add-On',
    bundlerAppDisallow: 'Bundler App Disallow',
    discountAddOn: 'Bundler App Discount Add-On',
    possibleChoices: 'Bundler App Possible Choices',
    possibleNighttimeChoices: 'Bundler App Possible Nighttime Choices',
};
exports.default = (function () { return __awaiter(void 0, void 0, void 0, function () {
    var clientArgs, res, products;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                clientArgs = (0, subscriptions_api_1.getClientArgs)({ path: '/collection-products/diapers' });
                return [4 /*yield*/, (0, unfetch_1.default)(clientArgs.uri, {
                        headers: __assign(__assign({}, clientArgs.headers), { 'Content-Type': 'application/json' }),
                    })];
            case 1:
                res = _a.sent();
                return [4 /*yield*/, res.json()];
            case 2:
                products = _a.sent();
                return [2 /*return*/, {
                        addOns: (0, flatten_add_ons_1.default)(products.filter(function (product) { return product.tags.includes(TAGS.addOn); })),
                        autoAddOns: (0, flatten_add_ons_1.default)(products.filter(function (product) { return product.tags.includes(TAGS.autoAddOn); })),
                        discountAddOns: (0, flatten_add_ons_1.default)(products.filter(function (product) { return product.tags.includes(TAGS.discountAddOn); })),
                        possibleChoices: products
                            // use bundlerAppDisallow tag to filter out products that shouldn't appear in checkout for now since these products are returned via shopify {{ collection | json }} and not API
                            .filter(function (product) { return product.tags.includes(TAGS.possibleChoices) && !product.tags.includes(TAGS.bundlerAppDisallow); })
                            .reduce(function (arr, product) { return arr.concat(product.variants); }, []),
                        possibleNighttimeChoices: products
                            // use bundlerAppDisallow tag to filter out products that shouldn't appear in checkout for now since these products are returned via shopify {{ collection | json }} and not API
                            .filter(function (product) { return product.tags.includes(TAGS.possibleNighttimeChoices) && !product.tags.includes(TAGS.bundlerAppDisallow); })
                            .reduce(function (arr, product) { return arr.concat(product.variants); }, []),
                    }];
        }
    });
}); });
